module.exports = __webpack_public_path__ + "img/sulfites.a1de5da1.svg";